import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  name: "", // Start with an empty name
  country: "",
  organization: "",
  current_role: "",
  isVerified: false,
};

const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    setProfileData: (state, action) => {
      const { name, value } = action.payload;
      state[name] = value;
    },
    setFullName: (state, action) => {
      state.name = action.payload;
    },
    setOrganization: (state, action) => {
      state.organization = action.payload;
    },
    resetProfile: (state) => {
      state.name = "";
      state.country = "";
      state.organization = "";
      state.current_role = "";
      state.isVerified = false;
    },
    setVerified: (state, action) => {
      state.isVerified = action.payload;
    },
  },
});

export const {
  setProfileData,
  resetProfile,
  setFullName,
  setVerified,
  setOrganization,
} = profileSlice.actions;
export default profileSlice.reducer;
